import type { Page } from '@/domain/model/Page';
import type { Polo, UpsertPoloCommand } from '@/domain/model/Polo';
import type { PoloGateway, ListPolosParams } from '@/application/port/out/PoloGateway';
import type {
  ListPolosUseCase, GetPoloUseCase, CreatePoloUseCase,
  UpdatePoloUseCase, DeactivatePoloUseCase,
} from '@/application/port/in/PoloUseCase';

export class ListPolos implements ListPolosUseCase {
  constructor(private readonly g: PoloGateway) {}
  execute(params: ListPolosParams): Promise<Page<Polo>> { return this.g.list(params); }
}
export class GetPolo implements GetPoloUseCase {
  constructor(private readonly g: PoloGateway) {}
  execute(id: string): Promise<Polo> { return this.g.get(id); }
}
export class CreatePolo implements CreatePoloUseCase {
  constructor(private readonly g: PoloGateway) {}
  execute(cmd: UpsertPoloCommand): Promise<Polo> { return this.g.create(cmd); }
}
export class UpdatePolo implements UpdatePoloUseCase {
  constructor(private readonly g: PoloGateway) {}
  execute(id: string, cmd: UpsertPoloCommand): Promise<Polo> { return this.g.update(id, cmd); }
}
export class DeactivatePolo implements DeactivatePoloUseCase {
  constructor(private readonly g: PoloGateway) {}
  execute(id: string): Promise<Polo> { return this.g.deactivate(id); }
}
